<template>
    <div v-if="!cookiesAccepted" style="display: flex; align-items: center; justify-content: center;">
        <div v-if="personalize_cookies === false" class="cookie-banner">
            <h4>Esse site usa cookies!</h4><br>
            <p>
                Ao prosseguir, você concorda com a nossa
                <b><router-link to="/Privacy">Política de Privacidade</router-link></b>
                e com o uso dos cookies que nos permitem melhorar nossos serviços.
            </p>
            <div class="cookie-buttons">
                <button class="waves-effect waves-light btn btn-theme personalize-cookies"
                    @click="personalizeCookies"> Personalizar </button>
                <button class="waves-effect waves-light btn btn-theme accept-cookies"
                    @click="saveCookies"> Aceitar Cookies</button>
            </div>
        </div>
        <div v-else class="personalize-wrapper">
            <div class="personalize-banner">
                <h5>Cookies necessários (obrigatórios) </h5>
                <p>São de extrema importancia e fundamentais para o funcionamento básico do site.
                    Suas funções principais incluem autenticação, segurança, armazenamento de
                    preferências do usuário, gerenciamento de sessões e aprimoramento da
                    experiência do usuário.
                </p>
                <p>De acordo com as regulamentações de privacidade,
                    cookies necessários são geralmente isentos dos requisitos de consentimento,
                    pois são essenciais para fornecer os serviços solicitados pelo usuário.</p>
                <h5>Cookies de preferências : <SwitchOnOff v-model="preferences['active']" /></h5>
                <p>
                    Os Cookies de Preferências desempenham um papel fundamental ao proporcionar
                    uma experiência personalizada aos usuários. Ao armazenar escolhas individuais,
                    como idioma, configurações de privacidade e preferências de exibição, esses
                    cookies garantem uma interação mais personalizada e conveniente.
                    Sua funcionalidade central reside em adaptar o site às preferências
                    específicas de cada usuário, promovendo assim uma navegação mais eficiente
                    e satisfatória.
                </p>
                <h5>Cookies de estatísticas : <SwitchOnOff v-model="statistics['active']" /></h5>
                <p>
                    Os Cookies de Estatísticas desempenham um papel crucial na coleta de informações
                    sobre a interação dos usuários com um site.
                    Utilizados por serviços como o Google Analytics, esses cookies registram dados
                    como páginas visitadas, tempo de permanência e origem do tráfego. 
                    Essas informações oferecem aos proprietários de sites insights valiosos para 
                    otimizar o conteúdo e melhorar a experiência do usuário.
                    O consentimento do usuário é fundamental, conforme exigido por regulamentações de 
                    privacidade, como o GDPR, garantindo transparência e respeito à privacidade
                    durante a navegação.
                </p>
            </div>
            <div class="cookie-buttons">
                <button class="waves-effect waves-light btn btn-theme accept-cookies"
                    @click="saveCookies"> Salvar Opções e <b>Aceitar</b> </button>
            </div>
        </div>
    </div>
</template>
<script>
import SwitchOnOff from '@/components/utils/SwitchOnOff'

export default {
    name: "CookiesAcceptDecline",
    components: {
        SwitchOnOff: SwitchOnOff
    },
    data() {
        return {
            functional: { active: true, required: true },
            preferences: { active: true, required: false },
            statistics: { active: true, required: false },
            personalize_cookies: false,
            cookiesAccepted: false,
        }
    },
    methods: {
        personalizeCookies() {
            this.personalize_cookies = true
        },
        saveCookies() {
            this.setCookies()
        },
        setCookies() {
            const options = {
                "personalized": {
                    'functional': true,
                    'preferences': this.preferences['active'],
                    'statistics': this.statistics['active']
                }
            };
            
            const options_str = JSON.stringify(options);
            const encoded_options = encodeURIComponent(options_str);
            const expirationDate = new Date('Thu, 31 Dec 2099 23:59:59 UTC');
            
            const cookieString = `cookie_consent=1; expires=${expirationDate.toUTCString()}; path=/; SameSite=Lax`;
            const optCookieString = `${encoded_options}; expires=${expirationDate.toUTCString()}; SameSite=Lax; path=/`;

            document.cookie = cookieString;
            document.cookie = optCookieString;
            this.cookiesAccepted = true
        },
        checkCookies() {
            if (document.cookie.indexOf("cookie_consent=1") === -1 ) {
                this.cookiesAccepted = false
            } else {
                this.cookiesAccepted = true
            }
            return this.cookiesAccepted
        }
    },
    mounted() {
        this.checkCookies();
    },
}
</script>
<style>
.cookie-banner,
.personalize-wrapper {
    text-align: center;
    width: 100%;
    height: 100%;
    top: 60%;
    color: rgb(0, 0, 0);
    z-index: 2;
    background-color: #fefefe;
    padding: 15px;
    font-size: medium;
    display: flex;
    flex-direction: column;
    position: fixed;
    box-shadow: 0 -1px 25px 0 #9393934d;
    border-radius: 4px;
}
.personalize-wrapper {
    text-align: left;
    top: 30%;
}
.cookie-buttons {
    width: 100%;
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-top: 25px;
}
.cookie-buttons button {
    font-size: medium;
    width: 20%;
    height: 40px;
    border-radius: 4px;
}
.personalize-cookies {
    color: black;
    background-color: aliceblue !important;
    width: auto !important;
}
.accept-cookies {
    color: rgb(255, 255, 255);
    background-color: #e6f7f8;
    width: auto !important;
}
.personalize-banner {
    border-radius: 2px;
    background-color: #ececec !important;
    border-radius: 4px;
    width: 100% !important;
    height: auto;
    max-height: 400px;
    overflow-y: auto;
    padding: 10px;
}
.personalize-banner h5 {
    font-size: 22px !important;
    display: flex;
    gap: 50px
}

@media screen and (device-width: 375px) and (device-height: 667px) {
    .cookie-banner,
    .personalize-wrapper {
        top: 45%;
    }
    .personalize-wrapper {
        top: 25%;
    }
}

</style>


// WEBPACK FOOTER //
// src/components/CookiesAcceptDecline.vue